import * as React from "react";
import * as ReactDOM from "react-dom";
import * as jQuery from "jquery";
import {ISdata, IUploadImages} from '../../../interfaces/models/IEvent';
import CropImageUploader from '../CropImageUploader';
declare var _root:any;
declare var window:any;
interface IEventEditHeaderImageProps {
    headerImage:string
    editMode:boolean
}

interface IEventEditHeaderImageState {
    headerImage:string
    removeHeaderImage:boolean
    headerImageCanvas:any
}

class EventEditHeaderImageComp extends React.Component<IEventEditHeaderImageProps, IEventEditHeaderImageState>{

    constructor(props:IEventEditHeaderImageProps){
        super(props);
        this.init();
    }

    private init(){
        var headerImage = null;
        if ( this.props.headerImage !== undefined && this.props.headerImage !== null && this.props.headerImage !== '' ) {
            headerImage = this.props.headerImage;
        }
        this.state = {
            headerImage: headerImage,
            removeHeaderImage: false,
            headerImageCanvas: {
                x: 0,
                y: 0,
                scale: 1
            }
        };
    }

    protected setFile(file):void{
		var removeImage:boolean = false;
		if ( file === null ) {
			removeImage = true;
            if ( window.temp === undefined ) {
                window.temp = {};
            }
            window.temp.smallFile = '';
		}
        this.setState({
            headerImage: file,
			removeHeaderImage: removeImage
        } as IEventEditHeaderImageState);
    }

    protected canvasChangedHandler(positions:any): void {
        if ( this.state.headerImageCanvas !== positions) {
            this.setState({
                headerImageCanvas: positions
            } as IEventEditHeaderImageState);
        }
    }

    render() {
        var headerImage = this.state.headerImage;
        if ( this.props.editMode === undefined || this.props.editMode === false ) {
            return(
                <div>
                    <div className="event_view">
                        { headerImage !== null?<div>
                            <img src={ headerImage } />
                        </div>:'' }

                    </div>
                </div>
            );
        }else{
            return (
                <div>
                    <div className="row">
                        <div className="row">
                            <div className="box crop_image_uploader_box">
                                <CropImageUploader
                                    x={ this.state.headerImageCanvas.x }
                                    y={ this.state.headerImageCanvas.y }
                                    scale={ this.state.headerImageCanvas.scale }
                                    file={ headerImage }
                                    setFile={ file => this.setFile(file) }
                                    refreshCanvas={ positions => this.canvasChangedHandler(positions) }
                                    sizes = { [ {width: 1366, height: 768 } ] }
                                    cropSize = { {width: 790, height: 410 } }
                                    uploadButtonName = "Fejléckép feltöltése"
                                    removeLabel="Fejléckép törlése"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            );
        }
    }
}

export class IniteventEditHeaderImageComp {
    constructor() {
        var div: HTMLDivElement = document.getElementById('even_edit_header_image_component') as HTMLDivElement;
        if (div !== null) {
            var data = div.dataset;
            var editMode:boolean = data.editMode === 'true'? true : false;
            var headerImage:string = data.headerImage;
            ReactDOM.render(< EventEditHeaderImageComp editMode={editMode} headerImage={headerImage}/>, div);
        }
    }
}
export class ReIniteventEditHeaderImage {
    constructor(headerImage:string, editMode:boolean) {
        var div: HTMLDivElement = document.getElementById('even_edit_header_image_component') as HTMLDivElement;
        if (div !== null) {
            ReactDOM.unmountComponentAtNode(div);
            ReactDOM.render(< EventEditHeaderImageComp editMode={editMode} headerImage={headerImage}/>, div);
        }
    }
}



// WEBPACK FOOTER //
// ./components/event/EventEditHeaderImage.tsx